export default {
  title: '视频项目',
  titleAndImage: '视频&图片项目',
  desc: '在线视频与图片制作工具：一键做图、混剪、AI配音、背景去除、视频多语言与多尺寸适配等功能。',
  addProject: {
    add: '新建项目',
    addBlank: '新建-视频编辑制作',
    addAI: '新建-AI视频编辑制作',
    popover: {
      addBlank: '视频编辑器',
      addTemplate: '布局模板',
      addAI: 'AI视频编辑器',
    },
    success: '创建项目成功',
  },
  tab: {
    normal: '视频编辑器',
    ai: 'AI视频编辑器',
    aiBanner: '链接生图',
  },
  select: {
    name: '项目名称',
    projectName: '产品名称',
  },
  drop: {
    addProject: {
      title: '新建视频项目',
    },
    text: '项目名称',
    language: '语言',
    cancal: '取消',
    sure: '确认',
    copyProject: {
      title: '复制项目',
    },
    delProject: {
      title: '删除该项目',
      text: '删除后将无法恢复，确定删除吗？',
      demoText: '当前项目为 demo 项目，删除后如需恢复请联系销售。确认删除吗？',
    },
  },
  empty: {
    title1: '无结果',
    desc1: '抱歉，没有找到符合条件的结果，建议更换不同的搜索条件。',
    title2: '暂无数据',
    desc2: '您还没有自己的视频项目，立即开始制作吧！',
  },
  table: {
    name: '项目名称及ID',
    operation: {
      title: '操作',
      lock: '锁定',
      lockTips: '锁定后该项目无法删除和保存，确定锁定吗？',
      lockSuccessTips: '锁定成功',
      unlock: '解锁',
      unlockText: '解锁',
      unlockTips: '解锁后该项目可以被删除和保存，确定解锁吗？',
      unlockSuccessTips: '解锁成功',
      lockText: '锁定',
      copy: '复制',
      edit: '编辑',
      prejectInfo: '查看详情',
      delete: '删除',
    },
    projectName: '产品名称',
    language: '语言',
    time: '时长',
    exportNum: '导出成功次数',
    updateTime: '更新时间',
    createTime: '创建时间',
    projectLocked: '该项目已被锁定。',
    projectLockedDeleteTip: '该项目已被锁定，不可删除。',
    projectLockedEditTip: '该项目已被锁定，不可编辑。',
    groupTotal: '批量组合数',
    exportTotal: '导出任务数',
    exportCountTips: '导出成功数 / 导出作品总数',
  },
  projectDrop: {
    tabs1: '项目详情',
    tabs2: '导出历史',
    title1: '基础信息',
    info: {
      name: '项目名称',
      id: '项目ID',
      time: '项目时长',
      exportNum: '导出次数',
      founder: '创建人',
      updater: '最后更新人',
      updateTime: '更新时间',
      productName: '产品名称',
      templateName: '模板名称',
      ratios: '项目尺寸',
      mainRatio: '创意主尺寸',
      languages: '项目语言',
    },
    title2: '关联的推广产品',
    associate: {
      title: '暂无数据',
      desc: '将项目和已有的产品进行关联！',
      add: '关联推广产品',
      select: '选择推广产品',
      new: '新增推广产品',
      placeholder: '请搜索关键词进行选择',
      info: {
        package: '包名',
        desc: '描述',
      },
    },
    subtitle: {
      editAndExport: '编辑&导出信息',
    },
  },
  filter: {
    fabrication: {
      placeholder: '制作方式',
      normal: '普通制作',
      batch: '批量制作',
      simple: '快速替换',
    },
  },
  rulesTips: '项目名称不能为空',
  titleTips: '作品名称不能为空',
}
